import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class APRService implements OnInit
{
    private authorization : string =
      "";
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){
      this.authorization += session.idToken;
    }

    ngOnInit(){}
    listaAPRs(datos, callback){
      var formData: FormData;
      formData = new FormData();
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/listarAPRs",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarFuentesAgua(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/listarFuentesAgua",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarPlanesTarifarios(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/listarPlanesTarifarios",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarFuentesAguaPorMes(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/listarFuentesAguaPorMes",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    agregarFuenteAgua(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/agregarFuenteAgua",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    agregarPlanTarifario(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/agregarPlanTarifario",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editarFuenteAgua(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/editarFuenteAgua",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listaAPRsDeshabilitadas(datos, callback){
      var formData: FormData;
      formData = new FormData();
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/listarAPRsDeshabilitadas",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    detallesAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/detallesAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crearAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/crearAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editarAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/editarAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editarAPRPorUsuario(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/editarAPRPorUsuario",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editarPlanTarifarioAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/editarPlanTarifarioAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    agregarRangoPlanTarifario(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/agregarRangoPlanTarifario",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    eliminarRangoPlanTarifario(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/eliminarRangoPlanTarifario",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    eliminarPlanTarifario(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/eliminarPlanTarifario",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listarRangosPlanTarifario(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/listarRangosPlanTarifario",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    deshabilitarAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/deshabilitarAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    habilitarAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/apr/habilitarAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    reporteExcel(form){
      form.action= Constants.API_BASE + "/apr/reporteExcel";
      form.elements[0].value = this.session.currentUser.accessToken;
      form.elements[0].name = 'accessToken';
      form.submit();
    }

    recaudacionExcel(datos, form){
      form.action= Constants.API_BASE + "/apr/recaudacionDiariaExcel";
      form.elements[0].value = this.session.currentUser.accessToken;
      form.elements[1].value = datos.idAPR;
      form.elements[2].value = datos.diaRecaudacion;
      form.elements[0].name = 'accessToken';
      form.elements[1].name = 'idAPR';
      form.elements[2].name = 'diaRecaudacion';

      form.submit();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/apr/apr.service.ts